function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module block-quote/blockquotecommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import first from '@ckeditor/ckeditor5-utils/src/first';
/**
 * The block quote command plugin.
 *
 * @extends module:core/command~Command
 */

var BlockQuoteCommand = /*#__PURE__*/function (_Command) {
  _inherits(BlockQuoteCommand, _Command);

  var _super = _createSuper(BlockQuoteCommand);

  function BlockQuoteCommand() {
    _classCallCheck(this, BlockQuoteCommand);

    return _super.apply(this, arguments);
  }

  _createClass(BlockQuoteCommand, [{
    key: "refresh",
    value:
    /**
     * Whether the selection starts in a block quote.
     *
     * @observable
     * @readonly
     * @member {Boolean} #value
     */

    /**
     * @inheritDoc
     */
    function refresh() {
      this.value = this._getValue();
      this.isEnabled = this._checkEnabled();
    }
    /**
     * Executes the command. When the command {@link #value is on}, all top-most block quotes within
     * the selection will be removed. If it is off, all selected blocks will be wrapped with
     * a block quote.
     *
     * @fires execute
     * @param {Object} [options] Command options.
     * @param {Boolean} [options.forceValue] If set, it will force the command behavior. If `true`, the command will apply a block quote,
     * otherwise the command will remove the block quote. If not set, the command will act basing on its current value.
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var schema = model.schema;
      var selection = model.document.selection;
      var blocks = Array.from(selection.getTopMostBlocks());
      var value = options.forceValue === undefined ? !this.value : options.forceValue;
      model.change(function (writer) {
        if (!value) {
          _this._removeQuote(writer, blocks.filter(findQuote));
        } else {
          var blocksToQuote = blocks.filter(function (block) {
            // Already quoted blocks needs to be considered while quoting too
            // in order to reuse their <bQ> elements.
            return findQuote(block) || checkCanBeQuoted(schema, block);
          });

          _this._applyQuote(writer, blocksToQuote);
        }
      });
    }
    /**
     * Checks the command's {@link #value}.
     *
     * @private
     * @returns {Boolean} The current value.
     */

  }, {
    key: "_getValue",
    value: function _getValue() {
      var selection = this.editor.model.document.selection;
      var firstBlock = first(selection.getTopMostBlocks()); // In the current implementation, the block quote must be an immediate parent of a block element.

      return !!(firstBlock && findQuote(firstBlock));
    }
    /**
     * Checks whether the command can be enabled in the current context.
     *
     * @private
     * @returns {Boolean} Whether the command should be enabled.
     */

  }, {
    key: "_checkEnabled",
    value: function _checkEnabled() {
      if (this.value) {
        return true;
      }

      var selection = this.editor.model.document.selection;
      var schema = this.editor.model.schema;
      var firstBlock = first(selection.getSelectedBlocks());

      if (!firstBlock) {
        return false;
      }

      return checkCanBeQuoted(schema, firstBlock);
    }
    /**
     * Removes the quote from given blocks.
     *
     * If blocks which are supposed to be "unquoted" are in the middle of a quote,
     * start it or end it, then the quote will be split (if needed) and the blocks
     * will be moved out of it, so other quoted blocks remained quoted.
     *
     * @private
     * @param {module:engine/model/writer~Writer} writer
     * @param {Array.<module:engine/model/element~Element>} blocks
     */

  }, {
    key: "_removeQuote",
    value: function _removeQuote(writer, blocks) {
      // Unquote all groups of block. Iterate in the reverse order to not break following ranges.
      getRangesOfBlockGroups(writer, blocks).reverse().forEach(function (groupRange) {
        if (groupRange.start.isAtStart && groupRange.end.isAtEnd) {
          writer.unwrap(groupRange.start.parent);
          return;
        } // The group of blocks are at the beginning of an <bQ> so let's move them left (out of the <bQ>).


        if (groupRange.start.isAtStart) {
          var positionBefore = writer.createPositionBefore(groupRange.start.parent);
          writer.move(groupRange, positionBefore);
          return;
        } // The blocks are in the middle of an <bQ> so we need to split the <bQ> after the last block
        // so we move the items there.


        if (!groupRange.end.isAtEnd) {
          writer.split(groupRange.end);
        } // Now we are sure that groupRange.end.isAtEnd is true, so let's move the blocks right.


        var positionAfter = writer.createPositionAfter(groupRange.end.parent);
        writer.move(groupRange, positionAfter);
      });
    }
    /**
     * Applies the quote to given blocks.
     *
     * @private
     * @param {module:engine/model/writer~Writer} writer
     * @param {Array.<module:engine/model/element~Element>} blocks
     */

  }, {
    key: "_applyQuote",
    value: function _applyQuote(writer, blocks) {
      var quotesToMerge = []; // Quote all groups of block. Iterate in the reverse order to not break following ranges.

      getRangesOfBlockGroups(writer, blocks).reverse().forEach(function (groupRange) {
        var quote = findQuote(groupRange.start);

        if (!quote) {
          quote = writer.createElement('blockQuote');
          writer.wrap(groupRange, quote);
        }

        quotesToMerge.push(quote);
      }); // Merge subsequent <bQ> elements. Reverse the order again because this time we want to go through
      // the <bQ> elements in the source order (due to how merge works – it moves the right element's content
      // to the first element and removes the right one. Since we may need to merge a couple of subsequent `<bQ>` elements
      // we want to keep the reference to the first (furthest left) one.

      quotesToMerge.reverse().reduce(function (currentQuote, nextQuote) {
        if (currentQuote.nextSibling == nextQuote) {
          writer.merge(writer.createPositionAfter(currentQuote));
          return currentQuote;
        }

        return nextQuote;
      });
    }
  }]);

  return BlockQuoteCommand;
}(Command);

export { BlockQuoteCommand as default };

function findQuote(elementOrPosition) {
  return elementOrPosition.parent.name == 'blockQuote' ? elementOrPosition.parent : null;
} // Returns a minimal array of ranges containing groups of subsequent blocks.
//
// content:         abcdefgh
// blocks:          [ a, b, d, f, g, h ]
// output ranges:   [ab]c[d]e[fgh]
//
// @param {Array.<module:engine/model/element~Element>} blocks
// @returns {Array.<module:engine/model/range~Range>}


function getRangesOfBlockGroups(writer, blocks) {
  var startPosition;
  var i = 0;
  var ranges = [];

  while (i < blocks.length) {
    var block = blocks[i];
    var nextBlock = blocks[i + 1];

    if (!startPosition) {
      startPosition = writer.createPositionBefore(block);
    }

    if (!nextBlock || block.nextSibling != nextBlock) {
      ranges.push(writer.createRange(startPosition, writer.createPositionAfter(block)));
      startPosition = null;
    }

    i++;
  }

  return ranges;
} // Checks whether <bQ> can wrap the block.


function checkCanBeQuoted(schema, block) {
  // TMP will be replaced with schema.checkWrap().
  var isBQAllowed = schema.checkChild(block.parent, 'blockQuote');
  var isBlockAllowedInBQ = schema.checkChild(['$root', 'blockQuote'], block);
  return isBQAllowed && isBlockAllowedInBQ;
}